import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { ReleaseNotes } from "./ReleaseNotes";

export function SidebarVersionIndicator() {
  const [open, setOpen] = useState(false);
  const [clientVersionId] = useLocalStorage<string | undefined>(
    "clientVersionId",
    undefined
  );
  const [clientVersion] = useLocalStorage<string | undefined>(
    "clientVersion",
    undefined
  );

  return (
    <>
      <button
        className="text-[.625rem] max-w-[52px] truncate overflow-ellipsis text-muted-foreground p-1 mb-2 rounded hover:bg-white/20"
        onClick={() => setOpen(true)}
      >
        {clientVersion || "v1.0.0"}
      </button>
      <AnimatePresence>
        {open && (
          <ReleaseNotes
            onOpenChange={setOpen}
            prevVersionId={clientVersionId}
          />
        )}
      </AnimatePresence>
    </>
  );
}
